export const APP_NAME = '甲醇燃料电池汽车运行状况AI诊断仿真平台'
